import { render, staticRenderFns } from "./TabNoteDetail.vue?vue&type=template&id=576a199c&scoped=true"
import script from "./TabNoteDetail.vue?vue&type=script&lang=js"
export * from "./TabNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./TabNoteDetail.vue?vue&type=style&index=0&id=576a199c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576a199c",
  null
  
)

export default component.exports